import script from "./FormSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=492621f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492621f2"]])

export default __exports__